import { Controller, useFormContext, useWatch } from 'react-hook-form';
import _ from 'lodash';
import { useMemo } from 'react';
import CustomDatePicker from '../../CustomDatePicker/CustomDatePicker';
import { DateField } from '../types';

const DateFieldForm = ({ field }: { field: DateField }) => {
  const {
    control,
    formState: { errors },
    setValue,
    getValues,
  } = useFormContext();
  const currentError = _.get(errors, field.key);

  const depsValues = useWatch({ control, name: field.deps ?? [] });
  const depsObj = useMemo(
    () =>
      field.deps?.length
        ? Object.fromEntries(field.deps.map((k, i) => [k, depsValues[i]]))
        : {},
    [depsValues, field.deps],
  );

  const resolvedMaxTime =
    typeof field.maxTime === 'function' ? field.maxTime(depsObj) : field.maxTime;
  const resolvedMinTime =
    typeof field.minTime === 'function' ? field.minTime(depsObj) : field.minTime;

  return (
    <div>
      <Controller
        name={field.key}
        control={control}
        render={({ field: renderField }) => (
          <CustomDatePicker
            label={field.label}
            date={renderField.value ? new Date(renderField.value) : null}
            disabled={typeof field.disabled === 'boolean' ? field.disabled : false}
            placeholder={field.placeholder}
            dateFormat={field.dateFormat}
            showTimeSelect={field.showTimeSelect}
            showTimeSelectOnly={field.showTimeSelectOnly}
            timeIntervals={field.timeIntervals}
            isClearable={field.isClearable}
            timeCaption={field.timeCaption}
            showIcon={field.showIcon}
            maxTime={resolvedMaxTime}
            minTime={resolvedMinTime}
            onChange={(date) => {
              renderField.onChange(date);
              field.onAfterChange?.(date, { setValue, getValues });
            }}
          />
        )}
      />
      {currentError && (
        <p className="text-danger" style={{ fontSize: 12 }}>
          {(currentError as any).message}
        </p>
      )}
    </div>
  );
};

export default DateFieldForm;
